import { render, staticRenderFns } from "./BotiIntro.vue?vue&type=template&id=52260d08&scoped=true&"
import script from "./BotiIntro.vue?vue&type=script&lang=js&"
export * from "./BotiIntro.vue?vue&type=script&lang=js&"
import style0 from "./BotiIntro.vue?vue&type=style&index=0&id=52260d08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52260d08",
  null
  
)

export default component.exports